import { useApiQuery } from 'theSource/utils';
import { LifeEventResponseDto } from './types';
import { GET_LIFE_EVENT_KEY } from './utils';

export interface UseLifeEventQueryProps {
  enabled: boolean;
}

export const useLifeEventQuery = ({ enabled }: UseLifeEventQueryProps) => {
  const { data, isLoading, isFetching } = useApiQuery<LifeEventResponseDto>({
    queryKey: GET_LIFE_EVENT_KEY,
    endpoint: '/life_events',
    enabled: enabled,
  });

  return {
    data,
    isLoading,
    isFetching,
  };
};
